<template>
  <div class="Drawingcontainer" ref="Drawingcontainer">
    <template v-if="!blankForGM">
      <div class="button-container">
        <div class="viewOnly" v-if="viewOnly">disabled</div>
        <select v-model="strokeType">
          <option value="dash">{{ t("line") }}</option>
          <!-- <option value="line">{{ t("straight line") }}</option> -->
          <option value="square">{{ t("square") }}</option>
          <!-- <option value="circle">{{ t("circle") }}</option>
        <option value="triangle">{{ t("triangle") }}</option> -->
          <!-- <option value="half_triangle">{{t("Half Triangle")}}</option> -->
        </select>
        <div id="farbauswahl">
          <div
            @click="setColor(f)"
            v-for="f in farben"
            :key="f"
            class="farben"
            v-bind:style="{ backgroundColor: f }"
          ></div>
        </div>
        <button
          style="width: 81px; margin-left: 10px"
          type="button"
          @click.prevent="fillShape = !fillShape"
        >
          <span v-if="fillShape">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              :fill="color"
              class="bi bi-square-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2z"
              />
            </svg>
            Fill
          </span>
          <span v-else>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              :fill="color"
              class="bi bi-square"
              viewBox="0 0 16 16"
            >
              <path
                d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
              />
            </svg>
            Border
          </span>
        </button>
        <button type="button" @click.prevent="$refs.VueCanvasDrawing.undo()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-arrow-counterclockwise"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z"
            />
            <path
              d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z"
            />
          </svg>
          back
        </button>
      </div>
    </template>
    <Barqdisplay
      :barqId="barqId"
      :viewPortHeight="viewPortHeight"
      :isMOS="isMOS"
      :status="status"
      :sprache="sprache"
    />
    <vue-drawing-canvas
      ref="VueCanvasDrawing"
      :canvasId="ZeichenbrettId"
      v-model:image="image"
      :stroke-type="strokeType"
      :fill-shape="fillShape"
      :eraser="eraser"
      :lineWidth="line"
      :color="color"
      :background-color="backgroundColor"
      :initialImage="initialImage"
      :lock="viewOnly"
      :width="CanvasWidth"
      :height="CanvasHeight"
      :line-cap="lineCap"
      :line-join="lineJoin"
      style="width: calc(100% + 336px); position: absolute; top: 0px"
      @mousemove="getCoordinate($event)"
    />
  </div>
</template>

<script>
// import VueDrawingCanvas from "vue-drawing-canvas";
import Barqdisplay from "./Barqdisplay";
import VueDrawingCanvas from "../../services/vue-drawing-canvas";
import Dict from "../../services/dict_new.js";
// import { gzip, ungzip } from "node-gzip";

import reduce from "lodash/reduce";

export default {
  name: "Drawing",
  components: {
    VueDrawingCanvas,
    Barqdisplay,
  },
  props: {
    isMOS: {
      type: Boolean,
      default: () => false,
    },
    status: {
      type: String,
      default: () => "non",
    },
    barqId: {
      type: String,
      default: () => "",
    },
    barqs: {
      type: Object,
      default: () => {},
    },
    sprache: {
      type: String,
      default: () => "english",
    },
    lock: {
      type: Boolean,
      default: () => false,
    },
    blankForGM: {
      type: Boolean,
      default: () => false,
    },
    viewPortHeight: {
      type: Number,
      default: () => -1,
    },
  },
  watch: {
    barqId: function (newVal) {
      // watch it
      if (this.barqs[newVal]) {
        console.log("INSIDE");

        if (this.barqs[this.barqId].dimensions) {
          this.CanvasWidth = this.barqs[this.barqId].dimensions.width;
          this.CanvasHeight = this.barqs[this.barqId].dimensions.height;
        }
        console.log(this.barqs[newVal].rawData);
        // this.initialImage = this.barqs[newVal].rawData;
        this.initialImage = this.loadInitialImage(
          this.barqs[this.barqId].rawData
        );
      }
    },
    lock: function (newVal) {
      this.viewOnly = newVal;
    },
  },
  emits: ["msg"],
  data() {
    return {
      ZeichenbrettId: this.barqId.replace("#", ""),
      x: 0,
      y: 0,
      image: "",
      eraser: false,
      disabled: false,
      fillShape: true,
      line: 5,
      color: "#595959",
      strokeType: "dash",
      backgroundColor: "transparent",
      initialImage: [],
      imgsrc: "",
      lineCap: "round",
      lineJoin: "round",
      viewOnly: this.lock,
      farben: [
        "#FF7C21",
        "#5182BB",
        "#0F7F12",
        "#FFFD38",
        "#fa00ff",
        "#595959",
      ],
      CanvasWidth: 1013,
      CanvasHeight: 680,
    };
  },

  methods: {
    t(word) {
      return Dict(word, this.sprache);
    },
    setColor(f) {
      this.color = f;
    },
    getImage() {
      // console.log(this.$refs.VueCanvasDrawing.getAllStrokes());
      // console.log(JSON.stringify(this.$refs.VueCanvasDrawing.getAllStrokes()));
      // var strokes = await gzip(
      //   JSON.stringify(this.$refs.VueCanvasDrawing.getAllStrokes())
      // );
      let strokes = [];
      const dim = { width: this.CanvasWidth, height: this.CanvasHeight };

      try {
        strokes = this.$refs.VueCanvasDrawing.getAllStrokes();
        // console.log(JSON.stringify(strokes));
        for (var i = 0; i < strokes.length; i++) {
          strokes[i].coordinates = reduce(
            strokes[i].coordinates,
            (coordinateArray, coordinate) => {
              coordinateArray.push([coordinate.x, coordinate.y]);
              return coordinateArray;
            },
            []
          );
        }
      } catch (e) {
        console.log(e);
        this.$emit("msg", "error while saving the drawing");
        return {
          img: "",
          barqId: this.barqId,
          dimensions: dim,
        };
      }

      // console.log(JSON.stringify(strokes));

      // let ctx = document.querySelector("#VueCanvasDrawing").getContext("2d");
      // ctx.setTransform(1, 0, 0, 1, 0, 0);
      // this.width = 780;
      // this.scale = 1;
      // this.height = 450;
      // this.$refs.VueCanvasDrawing.redraw();
      // // this.initialImage = strokes

      // const strokes2 = this.$refs.VueCanvasDrawing.getAllStrokes();
      // console.log(JSON.stringify(strokes2));
      // console.log(this.$refs.VueCanvasDrawing.save());
      console.log(dim);

      return { img: strokes, barqId: this.barqId, dimensions: dim };
      // this.$emit("getImage", { img: strokes, barqId: this.barqId });
      // this.$emit("closeBarq");
    },
    getCoordinate(event) {
      // console.log(this.$refs);
      if (!this.$refs.VueCanvasDrawing) return;
      let coordinates = this.$refs.VueCanvasDrawing.getCoordinates(event);
      this.x = coordinates.x;
      this.y = coordinates.y;
    },
    loadInitialImage(data) {
      console.log(data);
      try {
        for (var i = 0; i < data.length; i++) {
          data[i].coordinates = reduce(
            data[i].coordinates,
            (coordinateArray, coordinate) => {
              coordinateArray.push({ x: coordinate[0], y: coordinate[1] });
              return coordinateArray;
            },
            []
          );
        }
      } catch (e) {
        console.log(e);
        this.$emit("msg", "error while loading drawing");
      }
      // console.log(JSON.stringify(data));
      return data;
    },
  },
  created() {
    if (this.barqs[this.barqId]) {
      if (this.barqs[this.barqId].dimensions) {
        this.CanvasWidth = this.barqs[this.barqId].dimensions.width;
        this.CanvasHeight = this.barqs[this.barqId].dimensions.height;
      }
      this.initialImage = this.loadInitialImage(
        this.barqs[this.barqId].rawData
      );
    }
  },
  mounted() {
    const w = this.$refs.Drawingcontainer.clientWidth + 336;
    const h = this.$refs.Drawingcontainer.clientHeight;

    this.CanvasWidth = w;
    this.CanvasHeight = h;
  },
};
</script>

<style scoped>
.viewOnly {
  width: calc(100% - 45px);
  position: absolute;
  height: calc(100% - 4px);
  color: white;
  background: white;
  z-index: 2;
  margin-top: -2px;
}

.Drawingcontainer {
  max-width: calc(100% - 336px);
  z-index: 1;
  position: relative;
  aspect-ratio: 1;
}

.left {
  left: 4px;
}

.right {
  right: 4px;
}

.DecoText {
  font-size: 13px;
  position: absolute;
  top: 2px;
}

.Signature {
  margin-left: 37%;
  line-height: 61px;
}

.ml {
  margin-left: 5px;
}

.mr {
  margin-right: 5px;
}

.Signature > p:after {
  content: "";
  display: block;
  position: absolute;
  top: 14px;
  left: 265px;
  right: 0px;
  bottom: 0px;
  width: 158px;
  height: 33px;
  background-color: white;
  pointer-events: none;
}

#headline {
  height: 65px;
  text-align: center;
  line-height: 65px;
  font-size: 35px;
}

.backgroundImg {
  width: 500px;
  height: 500px;
  position: absolute;
  z-index: -1;
}

.inside {
  display: flex;
  height: 75%;
}

.imgOuter {
  width: 100%;
}

.inside > div > img {
  height: 100%;
  margin: 0 auto;
  display: block;
}

.bottom {
  margin-top: -16px;
  height: 65px;
  position: relative;
}

.Deco {
  height: 100%;
  width: 32px;
  background-color: white;
}

.Outline:before {
  border: 2px solid #fff;
  content: "";
  display: block;
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  border-radius: 70px;
  pointer-events: none;
}

.Outline {
  padding: 0 10px;
  border: 2px solid var(--barq-orange);
  border-radius: 70px;
  position: relative;
  background: var(--barq-orange);
  color: white;
  height: 100%;
}

#farbPalette {
  border: 1px solid black;
}
#master {
  position: relative;
}
vue-drawing-canvas {
  position: absolute;
}

.button-container {
  display: flex;
  position: absolute;
  margin-top: -41px;
  right: -338px;
  background: white;
  padding: 5px 9px;
  border: 3px solid var(--barq-orange);
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  border-bottom: none;
  padding-right: 97px;
}
.button-container > button,
.button-container > select {
  margin-right: 10px;
  background: hsl(0deg 0% 96%);
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: 1px solid hsl(0deg 0% 40%);
  border-radius: 5px;
  text-align: center;
}

#farbauswahl {
  display: flex;
  flex-wrap: wrap;
}

.farben {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin: 2px;
  border: 1px solid black;
}

.farben:hover {
  cursor: pointer;
}
</style>
